<template>
    <div>
        <div v-for="key in sections" class="mb-3">
            <h6 class="fw-bold">{{ key }}</h6>
            <div class="card bg-gray-100 p-3">
                <div v-for="file in documents[key]"
                     class="d-flex justify-content-between w-100 p-2 mb-3 rounded-3">
                    <div class="d-flex align-items-center text-primary doc-name" >
                        <div class="max-w-50 me-2 "><i class="fi fi-rr-document"></i></div>
                        <div class="name ">{{ file.name || file.path.split('/').slice(-1)[0] }}</div>
                    </div>
                    <div class="actions">
                        <a :href="file.absolute_path" download type="button" class="btn btn-circle btn-sm btn-download btn-secondary ">
                            <i class="fi fi-rr-download"></i>
                        </a>
                        <button type="button" class="btn btn-circle btn-sm btn-delete btn-secondary " v-on:click="deleteDocument(file.id)">
                            <i class="fi fi-rr-cross"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-center" v-if="lastPage > pageNum">
            <button class="btn btn-open btn-secondary " ref="show_more" v-on:click="showMore">
                <span class="text"  v-if="!$wait.is(LOAD_ATTACHMENTS)">{{ trans('general.defaults.show_more')}}</span>
                <waiting-indicator-icon :color="'#503E9D'" :name="LOAD_ATTACHMENTS" />
            </button>
        </div>

        <no-content-placeholder
            v-if="sections.length === 0"
            icon="fi-rr-clip"
            :title="trans('general.page.space_billing.payment.messages.no_attachments')"/>
    </div>
</template>

<script>
import moment from "moment/moment";
import WaitingIndicatorIcon from "../../../theme/atoms/WaitingIndicatorIcon.vue";
import NoContentPlaceholder from "../../../theme/organisms/NoContentPlaceholder.vue";

const LOAD_ATTACHMENTS = 'loadAttachments';

export default {
    name: "PaymentDocumentsList",
    props: {
        page: Number | String,
        limit: Number | String,
        paymentId: Number | String,
        isAdmin: Boolean
    },
    components: {
        WaitingIndicatorIcon,
        NoContentPlaceholder
    },
    data() {
        return {
            sections: [],
            documents: {},
            pageNum: this.page ?? 1,
            size: this.limit || 10,
            lastPage: 1,
            LOAD_ATTACHMENTS
        }
    },
    methods: {
        showMore: function () {
            this.pageNum = this.pageNum + 1;
            this.load();
        },
        load: function () {
            if (!this.paymentId) return;

            this.$wait.start(LOAD_ATTACHMENTS);
            axios.get( `/space/billing/payments/${this.paymentId}/list-documents?page=${this.pageNum}&limit=${this.size}`)
                .then(res => {
                    const response = res.data.data
                    const documents = response.data

                    this.lastPage = response.last_page
                    for (const document of documents) {
                        const date = moment(document.created_at).format('DD-MM-YYYY');
                        Array.isArray(this.documents[date])
                            ? this.documents[date].push(document) : this.documents[date] =  [document];
                    }

                    this.sections = Object.keys(this.documents)
                    this.$wait.end(LOAD_ATTACHMENTS);
                    this.$emit('documents-total', response.total);
                }).catch(e =>  this.$wait.end(LOAD_ATTACHMENTS))
        },
        reload: function () {
            this.pageNum =  1;
            this.sections =[];
            this.documents = {};

            this.load();
        },
        deleteDocument: function (id) {
            axios.delete(`/media/${id}/`).then(() => {
                this.reload()
            })
        }
    },
    mounted() {
        this.load()
    }
}
</script>

<style scoped>

</style>
